import { FC } from 'react';
import striptags from 'striptags';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { IJourney } from '../../../apis/journeys';
import { JourneyIcon } from '../journey-icon';

export interface JourneyCardProps {
  journey: IJourney;
  onClick: (slug: string) => void;
}

export const JourneyCard: FC<JourneyCardProps> = ({ journey, onClick }) => {
  const { slug, title, description, audiences, steps } = journey;
  const stepCount = steps.length;

  return (
    <button
      type="button"
      className="xvia-journey-card"
      onClick={() => onClick(slug)}
    >
      <span className="xvia-journey-card__icon">
        <JourneyIcon
          slug={slug}
          audienceSlugs={audiences?.map((audience) => audience.slug)}
        />
      </span>
      <span className="xvia-journey-card__content">
        <span className="xvia-journey-card__title">{title}</span>
        {description && (
          <span className="xvia-journey-card__description">
            {striptags(description)}
          </span>
        )}
        {!!audiences?.length && (
          <span className="xvia-journey-card__audiences">
            {audiences.map((audience) => (
              <span key={audience.id} className="xvia-journey-card__audience">
                {audience.name}
              </span>
            ))}
          </span>
        )}
      </span>
      <span className="xvia-journey-card__footer">
        <span className="xvia-journey-card__steps">
          {stepCount} {stepCount === 1 ? 'etapa' : 'etapas'}
        </span>
        <ArrowForward />
      </span>
    </button>
  );
};
